import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.memoryStepThreeGroups.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getGroupsData = createSelector(
  (state) => state.memoryStepThreeGroups.data.memoryStepThreeGroups,
  (groups = []) => groups
);
const getCurrencyData = createSelector(
  (state) => state.memoryStepThreeGroups.data.currency,
  (currency = {}) => currency
);

export default {
  getCurrencyData,
  getGroupsData,
  getHasLoaded,
};
